module.exports = __webpack_public_path__ + "static/media/1HD.4537998a.mp4";